// src/components/Gantt/dependencyArrows.js
// Трасса стрелки: stub от границы предшественника наружу → вертикаль →
// горизонталь → горизонтальный вход в бок последователя.
//
// Координаты по X считаются из индексов дней и DW (чистая арифметика).
// Координаты по Y приходят снаружи - Map<taskId, yCenter>. Замер делает
// Gantt через DOM: константа «высота строки 47px» слишком хрупкая, любое
// расхождение с реальным layout уводит стрелки с каждой следующей строки.

const STUB = 16;

export function computeArrowPaths(rows, indexById, DW, yById) {
  if (!yById || yById.size === 0) return [];
  const paths = [];
  for (const group of rows) {
    for (const row of group.visibleRows) {
      const task = row.node;
      if (!task.dependencyId) continue;
      const pred = indexById.get(task.dependencyId);
      if (!pred) continue;
      const predRow = pred.row;
      const predY = yById.get(predRow.id);
      const succY = yById.get(row.id);
      if (predY === undefined || succY === undefined) continue;

      const type = task.dependencyType || "FS";
      const a = anchors(type, predRow.indices, row.indices, DW);
      const d = buildPath(a.fromX, predY, a.stubX, a.toX, succY);

      paths.push({
        id: row.id,
        d,
        overdue:
          predRow.node.status !== "closed" &&
          predRow.node.deadline < row.node.start,
      });
    }
  }
  return paths;
}

function anchors(type, predIdx, succIdx, DW) {
  const predLeft = predIdx.sIdx * DW;
  const predRight = (predIdx.eIdx + 1) * DW;
  const succLeft = succIdx.sIdx * DW;
  const succRight = (succIdx.eIdx + 1) * DW;

  switch (type) {
    case "SS":
      return { fromX: predLeft, stubX: predLeft - STUB, toX: succLeft };
    case "FF":
      return { fromX: predRight, stubX: predRight + STUB, toX: succRight };
    case "FS":
    default:
      return { fromX: predRight, stubX: predRight + STUB, toX: succLeft };
  }
}

function buildPath(fromX, fromY, stubX, toX, toY) {
  if (Math.abs(fromY - toY) < 1) {
    return `M ${fromX} ${fromY} L ${toX} ${toY}`;
  }
  return [
    `M ${fromX} ${fromY}`,
    `L ${stubX} ${fromY}`,
    `L ${stubX} ${toY}`,
    `L ${toX} ${toY}`,
  ].join(" ");
}

/**
 * Сравнение двух Map<string, number> по составу и значениям.
 * Нужно, чтобы замер Y не вызывал setState, если координаты не изменились:
 * ResizeObserver срабатывает часто, а фактического сдвига строк может не быть.
 * Без этой проверки каждая микро-перерисовка окна тянула бы пересчёт путей.
 */
export function mapsEqual(a, b) {
  if (a === b) return true;
  if (!a || !b) return false;
  if (a.size !== b.size) return false;
  for (const [key, value] of a) {
    if (b.get(key) !== value) return false;
  }
  return true;
}
